<template>
  <el-form
    ref="resetPasswordForm"
    :size="size"
    :model="resetPasswordForm"
    :rules="resetPasswordFormRules"
  >
    <el-form-item :label="$l('INDEX.security_old_pwd')" prop="password">
      <el-input v-model="resetPasswordForm.password" show-password></el-input>
    </el-form-item>
    <el-form-item :label="$l('INDEX.security_new_pwd')" prop="newPassword">
      <el-input
        v-model="resetPasswordForm.newPassword"
        show-password
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="$l('INDEX.security_check_pwd')"
      prop="confirmNewPassword"
    >
      <el-input
        v-model="resetPasswordForm.confirmNewPassword"
        show-password
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    model: { type: Object, default: () => {} },
    size: { type: String, default: 'medium' },
    userCode: { type: String, default: '' }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$l('INDEX.security_check_pwd_null_tips')))
      } else if (value !== this.resetPasswordForm.newPassword) {
        callback(new Error(this.$l('INDEX.security_check_pwd_tips')))
      } else {
        callback()
      }
    }
    return {
      resetPasswordForm: { userCode: this.userCode },
      resetPasswordFormRules: {
        password: [
          {
            required: true,
            message: this.$l('INDEX.security_old_pwd_null_tips'),
            trigger: 'blur'
          }
        ],
        newPassword: [
          {
            required: true,
            message: this.$l('INDEX.security_new_pwd_null_tips'),
            trigger: 'blur'
          },
          {
            pattern: '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$',
            message: this.$l('INDEX.security_new_pwd_check_complexity_tips'),
            trigger: 'blur'
          }
        ],
        confirmNewPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    resetPasswordForm(val) {
      this.$emit('update:model', val)
    }
  },
  methods: {
    async submit() {
      const res = await validate.formValidate([this.$refs.resetPasswordForm])
      if (res) {
        return await this.$api.SYS_USER_UPD_PWD(this.resetPasswordForm)
      }
      return Promise.reject()
    },
    resetFields() {
      this.$refs.resetPasswordForm.resetFields()
    }
  }
}
</script>
